export default __webpack_public_path__ + "static/media/icon-close-black.ab1c7977.svg";